var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-banner"},[_c('img',{attrs:{"src":_vm.banner}}),_c('div',{staticClass:"text-box"},[_c('div',{staticClass:"base-width"},[_c('div',{staticClass:"en"},[_vm._v(_vm._s(_vm.en))]),_c('div',{staticClass:"ch"},[_vm._v(_vm._s(_vm.ch))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }